import Encoding from "encoding-japanese";
import TextEncoding from "text-encoding";

/**
 * FileReaderのwrapper
 *
 * FileReaderはPromiseを扱えないので、ラッピングする
 */
export default class FileReaderWrapper {
  static readonly readAsDataURLErrors: Array<string> = [
    // エラーコードが1から始まるので0番目は空文字で定義
    "",
    "NOT_FOUND_ERR: ファイルが見つかりません",
    "SECURITY_ERR: セキュリティエラー",
    "ABORT_ERR: ファイルの読込みが中断されました",
    "NOT_READABLE_ERR: ファイルの読込み権限がありません",
    "ENCODING_ERR: サイズ上限を越えています"
  ];

  /**
   * readAsDataURL() wrapper
   *
   * @param file ファイル
   */
  public static async readAsDataURL(file: File): Promise<string> {
    const fileReader: FileReader = new FileReader();

    return new Promise((resolve: any, reject: any) => {
      // 成功の場合は処理結果をresolve
      fileReader.onload = () => {
        resolve(fileReader.result);
        return;
      };

      // 例外の場合はエラーコードからメッセージを作成してreject
      fileReader.onerror = (error: any) => {
        fileReader.abort();
        reject(new DOMException(this.readAsDataURLErrors[error]));
        return;
      };

      fileReader.readAsDataURL(file);
      return;
    });
  }

  /**
   * readAsDataURL() wrapper
   *
   * @param file ファイル
   */
  public static async getUnicodeText(file: File, allowdEncoding: string[], targetEncoding?: string): Promise<{ unicodeText: string; sourceEncoding: Encoding.Encoding } | null> {
    const fileReader: FileReader = new FileReader();

    return new Promise((resolve: any, reject: any) => {
      // 成功の場合は処理結果をresolve
      fileReader.onload = () => {
        // ファイル読込み結果(ArrayBuffer)をUint8Arrayに変換して使用する
        const codes: Uint8Array = new Uint8Array(fileReader.result as ArrayBuffer);

        // 引数でエンコーディングが指定されていなければ文字エンコーディングを自動判別
        let encoding: string | undefined = targetEncoding;
        if (encoding == undefined) {
          const encodingJapaneseEncoding: string | null = this.encodingJapaneseDetect(codes);
          if (encodingJapaneseEncoding == null) {
            return null;
          }

          encoding = encodingJapaneseEncoding;
        }
        console.debug("encoding:", encoding);

        // 許可された文字コードでなければ文字コード変換せずに文字エンコードをnullで返却する
        if (allowdEncoding.indexOf(encoding) == -1) {
          resolve({ unicodeText: "", sourceEncoding: null });
        }

        // デコード
        const unicodeString = new TextEncoding.TextDecoder(encoding).decode(codes);
        console.debug("loaded csv text:", unicodeString);

        resolve({ unicodeText: unicodeString, sourceEncoding: encoding });
      };

      // 例外の場合はエラーコードからメッセージを作成してreject
      fileReader.onerror = (error: any) => {
        fileReader.abort();
        reject(new DOMException(this.readAsDataURLErrors[error]));
        return;
      };

      fileReader.readAsArrayBuffer(file);
      return;
    });
  }

  public static encodingJapaneseDetect(codes: Uint8Array): string | null {
    const encoding: Encoding.Encoding | false = Encoding.detect(codes);

    if (encoding == false) {
      return null;
    }

    switch (encoding) {
      case "UTF32":
        return "UTF-32";
      case "UTF16":
      case "UTF16BE":
      case "UTF16LE":
        return "UTF-16";
      case "UTF8":
        return "UTF-8";
      case "SJIS":
        return "SHIFT_JIS";
      default:
        return encoding;
    }
  }
}
